// Global JavaScript for Hustle Over Luck theme

// Cart count update
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        element.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(error => console.error('Error updating cart count:', error));
}

// Initialize cart count on page load
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
});

// Search Overlay
document.addEventListener('DOMContentLoaded', () => {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('.search-overlay__input');
  const header = document.querySelector('.header');
  const promotionalBanner = document.querySelector('.promotional-banner');
  
  if (!searchToggle || !searchOverlay) return;
  
  // Calculate header heights and set CSS variables
  function updateHeaderHeights() {
    let promotionalBannerHeight = 0;
    let headerHeight = 0;
    
    if (promotionalBanner) {
      promotionalBannerHeight = promotionalBanner.offsetHeight;
      document.documentElement.style.setProperty('--promotional-banner-height', promotionalBannerHeight + 'px');
    } else {
      document.documentElement.style.setProperty('--promotional-banner-height', '0px');
    }
    
    if (header) {
      headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
    
    // Set search overlay top position to be right below header
    const totalTop = promotionalBannerHeight + headerHeight;
    searchOverlay.style.top = totalTop + 'px';
  }
  
  // Update heights on load and resize
  updateHeaderHeights();
  window.addEventListener('resize', updateHeaderHeights);
  
  // Open search overlay
  searchToggle.addEventListener('click', (e) => {
    e.preventDefault();
    updateHeaderHeights(); // Recalculate heights
    searchOverlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
    // Focus input after animation starts
    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
      }
    }, 150);
  });
  
  // Close search overlay
  function closeSearchOverlay(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    searchOverlay.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
    if (searchInput) {
      searchInput.blur();
      searchInput.value = '';
    }
  }
  
  // Close on backdrop click
  const searchBackdrop = document.querySelector('.search-overlay__backdrop');
  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', closeSearchOverlay);
  }
  
  // Close on X button click
  const searchCloseButtons = document.querySelectorAll('[data-search-close]');
  searchCloseButtons.forEach(button => {
    button.addEventListener('click', closeSearchOverlay);
  });
  
  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
      closeSearchOverlay();
    }
  });
  
  // Prevent form submission from closing overlay (let it navigate to search results)
  const searchForm = document.querySelector('.search-overlay__form');
  if (searchForm) {
    searchForm.addEventListener('submit', () => {
      // Allow form to submit and navigate to search results
      // Overlay will close naturally on navigation
    });
  }
});

// Search Results Tabs
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.search-results__tab');
  const tabContents = {
    products: document.getElementById('products-tab'),
    blogs: document.getElementById('blogs-tab'),
    pages: document.getElementById('pages-tab')
  };
  
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabName = tab.dataset.tab;
      
      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('search-results__tab--active'));
      
      // Add active class to clicked tab
      tab.classList.add('search-results__tab--active');
      
      // Hide all tab contents
      Object.values(tabContents).forEach(content => {
        if (content) {
          content.style.display = 'none';
        }
      });
      
      // Show selected tab content
      if (tabContents[tabName]) {
        tabContents[tabName].style.display = 'block';
      }
    });
  });
});

// Customer Addresses Management
document.addEventListener('DOMContentLoaded', () => {
  const addressFormWrapper = document.getElementById('address-form-wrapper');
  const addButton = document.querySelector('[data-address-add]');
  const cancelButton = document.querySelector('[data-address-cancel]');
  const editButtons = document.querySelectorAll('[data-address-edit]');
  const formTitle = document.getElementById('address-form-title');
  const addressForm = document.getElementById('address-form-new');
  
  // Show form for adding new address
  if (addButton && addressFormWrapper) {
    addButton.addEventListener('click', () => {
      // Hide all edit forms
      document.querySelectorAll('.customer-address__form-wrapper--edit').forEach(form => {
        form.style.display = 'none';
      });
      addressFormWrapper.style.display = 'block';
      if (formTitle) formTitle.textContent = 'ADD NEW ADDRESS';
      addressFormWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      
      // Initialize country/province selector for new address form
      if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountry', 'AddressProvince', {
          hideElement: 'AddressProvinceWrapper'
        });
      }
    });
  }
  
  // Hide new address form
  function hideNewForm() {
    if (addressFormWrapper) {
      addressFormWrapper.style.display = 'none';
      if (addressForm) {
        addressForm.reset();
      }
    }
  }
  
  if (cancelButton) {
    cancelButton.addEventListener('click', hideNewForm);
  }
  
  // Edit address functionality
  editButtons.forEach(button => {
    button.addEventListener('click', () => {
      const addressId = button.dataset.addressEdit;
      const editFormWrapper = document.getElementById(`address-form-edit-${addressId}`);
      
      if (editFormWrapper) {
        // Hide new address form
        if (addressFormWrapper) addressFormWrapper.style.display = 'none';
        // Hide all other edit forms
        document.querySelectorAll('.customer-address__form-wrapper--edit').forEach(form => {
          if (form.id !== `address-form-edit-${addressId}`) {
            form.style.display = 'none';
          }
        });
        // Show this edit form
        editFormWrapper.style.display = 'block';
        editFormWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        
        // Initialize country/province selector for edit form
        if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
          new Shopify.CountryProvinceSelector(`AddressCountry_${addressId}`, `AddressProvince_${addressId}`, {
            hideElement: `AddressProvinceWrapper_${addressId}`
          });
        }
      }
    });
  });
  
  // Cancel edit forms
  document.querySelectorAll('[data-address-cancel-edit]').forEach(button => {
    button.addEventListener('click', () => {
      const addressId = button.dataset.addressCancelEdit;
      const editFormWrapper = document.getElementById(`address-form-edit-${addressId}`);
      if (editFormWrapper) {
        editFormWrapper.style.display = 'none';
      }
    });
  });
  
  // Initialize country/province selector for new address form on page load
  if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector && addressForm) {
    new Shopify.CountryProvinceSelector('AddressCountry', 'AddressProvince', {
      hideElement: 'AddressProvinceWrapper'
    });
  }
});

// Quantity Selector
document.addEventListener('DOMContentLoaded', () => {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  quantitySelectors.forEach(selector => {
    const input = selector.querySelector('.quantity-selector__input');
    const decreaseBtn = selector.querySelector('[data-quantity-decrease]');
    const increaseBtn = selector.querySelector('[data-quantity-increase]');
    
    if (!input || !decreaseBtn || !increaseBtn) return;
    
    const min = parseInt(input.getAttribute('min')) || 1;
    const max = parseInt(input.getAttribute('max')) || Infinity;
    
    function updateButtons() {
      const value = parseInt(input.value) || min;
      decreaseBtn.disabled = value <= min;
      increaseBtn.disabled = value >= max;
    }
    
    decreaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || min;
      if (currentValue > min) {
        input.value = currentValue - 1;
        updateButtons();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    increaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || min;
      if (currentValue < max) {
        input.value = currentValue + 1;
        updateButtons();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    input.addEventListener('input', () => {
      let value = parseInt(input.value) || min;
      if (value < min) value = min;
      if (value > max) value = max;
      input.value = value;
      updateButtons();
    });
    
    // Initialize button states
    updateButtons();
  });
});

// Product gallery thumbnail switching and navigation
document.addEventListener('DOMContentLoaded', () => {
  const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
  const slides = document.querySelectorAll('.product-gallery__slide');
  const prevButton = document.querySelector('.product-gallery__nav--prev');
  const nextButton = document.querySelector('.product-gallery__nav--next');
  
  if (slides.length === 0) return;
  
  let currentSlideIndex = 0;
  let isTransitioning = false;
  
  function showSlide(index, direction = 'next') {
    if (index < 0 || index >= slides.length || index === currentSlideIndex || isTransitioning) return;
    if (index === currentSlideIndex) return;
    
    isTransitioning = true;
    
    const currentSlide = slides[currentSlideIndex];
    const newSlide = slides[index];
    
    // Determine direction based on index
    const actualDirection = index > currentSlideIndex ? 'next' : 'prev';
    
    // Remove active class from current slide
    if (currentSlide) {
      currentSlide.classList.remove('active');
      if (actualDirection === 'next') {
        currentSlide.style.transform = 'translateX(-100%)';
        currentSlide.style.opacity = '0';
      } else {
        currentSlide.style.transform = 'translateX(100%)';
        currentSlide.style.opacity = '0';
      }
    }
    
    // Position new slide and add active class
    newSlide.style.transform = actualDirection === 'next' ? 'translateX(100%)' : 'translateX(-100%)';
    newSlide.style.opacity = '0';
    newSlide.classList.add('active');
    
    // Trigger animation
    requestAnimationFrame(() => {
      newSlide.style.transform = 'translateX(0)';
      newSlide.style.opacity = '1';
    });
    
    // Update thumbnails
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === index);
    });
    
    currentSlideIndex = index;
    
    // Reset transition flag after animation
    setTimeout(() => {
      isTransitioning = false;
      if (currentSlide) {
        currentSlide.style.transform = '';
        currentSlide.style.opacity = '';
      }
      newSlide.style.transform = '';
      newSlide.style.opacity = '';
    }, 600);
  }
  
  function nextSlide() {
    const next = (currentSlideIndex + 1) % slides.length;
    showSlide(next, 'next');
  }
  
  function prevSlide() {
    const prev = (currentSlideIndex - 1 + slides.length) % slides.length;
    showSlide(prev, 'prev');
  }
  
  // Thumbnail clicks
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      const direction = index > currentSlideIndex ? 'next' : 'prev';
      showSlide(index, direction);
    });
  });
  
  // Navigation buttons
  if (nextButton) {
    nextButton.addEventListener('click', nextSlide);
  }
  
  if (prevButton) {
    prevButton.addEventListener('click', prevSlide);
  }
  
  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (slides.length === 0) return;
    if (e.key === 'ArrowLeft') prevSlide();
    if (e.key === 'ArrowRight') nextSlide();
  });
});

// Sticky add to cart
document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.getElementById('sticky-add-to-cart');
  if (!stickyCart) return;
  
  const productDetails = document.querySelector('.product-details');
  if (!productDetails) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyCart.classList.add('active');
      } else {
        stickyCart.classList.remove('active');
      }
    });
  }, {
    threshold: 0.1
  });
  
  observer.observe(productDetails);
});

// Variant selection
document.addEventListener('DOMContentLoaded', () => {
  const variantSelect = document.getElementById('ProductSelect');
  if (!variantSelect) return;
  
  const optionSelects = document.querySelectorAll('.product-form__option-select');
  
  function updateVariant() {
    const selectedOptions = Array.from(optionSelects).map(select => select.value);
    
    // Find matching variant by comparing options
    const variantOptions = Array.from(variantSelect.options);
    let selectedVariant = null;
    
    variantOptions.forEach(option => {
      const variantId = option.value;
      // This will be handled by the form submission, but we can update UI here
    });
    
    // Update form to reflect selection
    const form = document.getElementById('product-form');
    if (form) {
      // The form will handle variant selection on submit
      // For now, just ensure the variant select matches
    }
  }
  
  optionSelects.forEach(select => {
    select.addEventListener('change', () => {
      // Update variant select based on option selections
      const form = variantSelect.closest('form');
      if (form) {
        // Trigger variant update
        const event = new Event('change', { bubbles: true });
        variantSelect.dispatchEvent(event);
      }
    });
  });
  
});

// Hero Banner Carousel
document.addEventListener('DOMContentLoaded', () => {
  const heroBanner = document.querySelector('.hero-banner');
  if (!heroBanner) return;
  
  const slides = heroBanner.querySelectorAll('.hero-banner__slide');
  const indicators = heroBanner.querySelectorAll('.hero-banner__indicator');
  const autoRotate = heroBanner.dataset.autoRotate === 'true';
  const rotationSpeed = parseInt(heroBanner.dataset.rotationSpeed) * 1000 || 5000;
  
  if (slides.length <= 1) return;
  
  let currentSlide = 0;
  let rotationInterval;
  
  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
    
    indicators.forEach((indicator, i) => {
      indicator.classList.toggle('active', i === index);
    });
    
    currentSlide = index;
  }
  
  function nextSlide() {
    const next = (currentSlide + 1) % slides.length;
    showSlide(next);
  }
  
  function startRotation() {
    if (autoRotate) {
      rotationInterval = setInterval(nextSlide, rotationSpeed);
    }
  }
  
  function stopRotation() {
    if (rotationInterval) {
      clearInterval(rotationInterval);
    }
  }
  
  // Indicator clicks
  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', () => {
      stopRotation();
      showSlide(index);
      startRotation();
    });
  });
  
  // Pause on hover
  heroBanner.addEventListener('mouseenter', stopRotation);
  heroBanner.addEventListener('mouseleave', startRotation);
  
  // Start rotation
  startRotation();
});

// Product card scroll animation (fade in from left)
document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('[data-product-card]');
  
  if (productCards.length === 0) return;
  
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add a slight delay for staggered animation
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, index * 100);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  productCards.forEach(card => {
    observer.observe(card);
  });
});

// Category banner zoom effect on scroll
document.addEventListener('DOMContentLoaded', () => {
  const categoryBanners = document.querySelectorAll('[data-category-banner]');
  
  if (categoryBanners.length === 0) return;
  
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  categoryBanners.forEach(banner => {
    observer.observe(banner);
  });
});

// Header fade-up animation on scroll
document.addEventListener('DOMContentLoaded', () => {
  // Find all section headings (h1, h2, h3) that are not in hero banner or product details
  const headers = document.querySelectorAll('h1:not(.hero-banner__heading):not(.product-details__title), h2:not(.hero-banner__heading), h3:not(.hero-banner__heading)');
  
  if (headers.length === 0) return;
  
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add a slight delay for staggered animation
        setTimeout(() => {
          entry.target.style.opacity = '0';
          entry.target.style.transform = 'translateY(30px)';
          entry.target.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          
          // Trigger animation
          requestAnimationFrame(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          });
        }, index * 50);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  headers.forEach(header => {
    // Skip headers that are already in viewport on load
    const rect = header.getBoundingClientRect();
    const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (!isInViewport) {
      // Set initial state
      header.style.opacity = '0';
      header.style.transform = 'translateY(30px)';
      header.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      observer.observe(header);
    }
  });
});

// Cart Drawer
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.querySelector('[data-cart-drawer-toggle]');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  
  if (!cartDrawer) return;
  
  // Open cart drawer
  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  
  // Close cart drawer
  function closeCartDrawer() {
    cartDrawer.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }
  
  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }
  
  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer.classList.contains('active')) {
      closeCartDrawer();
    }
  });
  
  // Helper function to format money
  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(cents / 100);
  }
  
  // Attach event listeners to cart drawer buttons
  function attachCartDrawerListeners() {
    // Quantity buttons
    const quantityButtons = document.querySelectorAll('.cart-drawer__quantity-btn');
    quantityButtons.forEach(button => {
      // Remove existing listeners by cloning
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', async () => {
        const itemKey = newButton.dataset.cartItemKey;
        const newQuantity = parseInt(newButton.dataset.quantity);
        
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: newQuantity
            })
          });
          
          const cart = await response.json();
          updateCartDrawer(cart);
          updateCartCount();
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      });
    });
    
    // Remove buttons
    const removeButtons = document.querySelectorAll('.cart-drawer__item-remove');
    removeButtons.forEach(button => {
      // Remove existing listeners by cloning
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', async () => {
        const itemKey = newButton.dataset.cartItemKey;
        
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0
            })
          });
          
          const cart = await response.json();
          updateCartDrawer(cart);
          updateCartCount();
        } catch (error) {
          console.error('Error removing item:', error);
        }
      });
    });
  }
  
  // Attach initial cart drawer listeners
  attachCartDrawerListeners();
  
  // Update cart drawer content
  async function updateCartDrawer(cart) {
    const cartItemsContainer = document.querySelector('[data-cart-drawer-items]');
    const cartCount = document.querySelector('[data-cart-drawer-count]');
    const cartTotal = document.querySelector('[data-cart-total]');
    
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }
    
    if (cartTotal) {
      cartTotal.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cart.currency
      }).format(cart.total_price / 100);
    }
    
    if (cartItemsContainer) {
      if (cart.item_count === 0) {
        cartItemsContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p class="cart-drawer__empty-text">Your cart is currently empty.</p>
          </div>
        `;
      } else {
        // Build cart items HTML dynamically
        let itemsHTML = '';
        cart.items.forEach(item => {
          const imageUrl = item.image ? item.image : '';
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : '';
          
          itemsHTML += `
            <div class="cart-drawer__item" data-cart-item-key="${item.key}">
              <div class="cart-drawer__item-image">
                ${imageUrl ? `<img src="${imageUrl}" alt="${item.product_title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
              </div>
              <div class="cart-drawer__item-details">
                <h3 class="cart-drawer__item-title">${item.product_title}</h3>
                ${variantTitle}
                <div class="cart-drawer__item-price">${formatMoney(item.final_line_price, cart.currency)}</div>
                <div class="cart-drawer__item-quantity">
                  <button class="cart-drawer__quantity-btn" data-cart-item-key="${item.key}" data-quantity="${item.quantity - 1}">−</button>
                  <span class="cart-drawer__quantity-value">${item.quantity}</span>
                  <button class="cart-drawer__quantity-btn" data-cart-item-key="${item.key}" data-quantity="${item.quantity + 1}">+</button>
                </div>
              </div>
              <button class="cart-drawer__item-remove" data-cart-item-key="${item.key}" aria-label="Remove item">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
          `;
        });
        cartItemsContainer.innerHTML = itemsHTML;
        
        // Re-attach event listeners to new buttons
        attachCartDrawerListeners();
      }
    }
  }
  
  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          element.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }
  
  // Product form submission - AJAX add to cart
  const productForm = document.getElementById('product-form');
  if (productForm) {
    // Remove any existing listeners by cloning the form
    const newForm = productForm.cloneNode(true);
    productForm.parentNode.replaceChild(newForm, productForm);
    
    newForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const submitButton = newForm.querySelector('button[type="submit"]');
      if (!submitButton) return;
      
      const originalText = submitButton.textContent;
      
      // Disable button and show loading state
      submitButton.disabled = true;
      submitButton.textContent = 'ADDING...';
      
      const formData = new FormData(newForm);
      const variantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: parseInt(quantity)
          })
        });
        
        if (response.ok) {
          const item = await response.json();
          
          // Fetch updated cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Update cart drawer and open it
          updateCartDrawer(cart);
          updateCartCount();
          
          // Open cart drawer
          cartDrawer.classList.add('active');
          document.body.style.overflow = 'hidden';
          
          // Reset button
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        } else {
          const error = await response.json();
          console.error('Error adding to cart:', error);
          alert('Error adding item to cart. Please try again.');
          
          // Reset button
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Error adding item to cart. Please try again.');
        
        // Reset button
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    });
  }
});

// Footer Newsletter Form
document.addEventListener('DOMContentLoaded', () => {
  const newsletterForm = document.querySelector('.footer__newsletter-form');
  const newsletterInput = document.getElementById('footer-newsletter-email');
  const errorMessage = newsletterForm?.querySelector('.footer__newsletter-error');
  
  if (newsletterForm && newsletterInput) {
    // Hide error message initially if it exists
    if (errorMessage && !errorMessage.textContent.trim()) {
      errorMessage.style.display = 'none';
    }
    
    // Email validation
    function validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
    
    function showError(message) {
      if (errorMessage) {
        errorMessage.textContent = message;
        errorMessage.style.display = 'block';
        newsletterInput.classList.add('footer__newsletter-input--error');
        newsletterInput.setAttribute('aria-invalid', 'true');
      }
    }
    
    function hideError() {
      if (errorMessage) {
        errorMessage.style.display = 'none';
        newsletterInput.classList.remove('footer__newsletter-input--error');
        newsletterInput.setAttribute('aria-invalid', 'false');
      }
    }
    
    // Clear error when user starts typing
    newsletterInput.addEventListener('input', () => {
      hideError();
      newsletterInput.setCustomValidity('');
    });
    
    // Validate on blur only if user has entered something
    newsletterInput.addEventListener('blur', (e) => {
      const email = e.target.value.trim();
      if (email && !validateEmail(email)) {
        showError('Please enter a valid email address');
        e.target.setCustomValidity('Please enter a valid email address');
      } else {
        hideError();
        e.target.setCustomValidity('');
      }
    });
    
    // Handle form submission - use iframe method to avoid page reload
    newsletterForm.addEventListener('submit', (e) => {
      const email = newsletterInput.value.trim();
      
      // Only validate if user has entered something
      if (!email) {
        e.preventDefault();
        showError('Email can\'t be blank');
        newsletterInput.focus();
        return false;
      }
      
      if (!validateEmail(email)) {
        e.preventDefault();
        showError('Please enter a valid email address');
        newsletterInput.focus();
        return false;
      }
      
      // Clear any previous errors
      hideError();
      
      // Prevent default submission
      e.preventDefault();
      
      // Create a hidden iframe for form submission (same method as discount popup)
      let iframe = document.getElementById('footer-newsletter-submit-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'footer-newsletter-submit-iframe';
        iframe.name = 'footer-newsletter-submit-iframe';
        iframe.style.display = 'none';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);
      }
      
      // Set form target to iframe
      const originalTarget = newsletterForm.getAttribute('target');
      newsletterForm.setAttribute('target', 'footer-newsletter-submit-iframe');
      
      // Listen for iframe load to detect submission completion
      iframe.onload = function() {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          const errors = iframeDoc.querySelector('.form-error, .errors, [class*="error"]');
          
          if (!errors) {
            // Success - show success message
            const successMessage = newsletterForm.querySelector('.footer__newsletter-success');
            if (!successMessage) {
              // Create success message if it doesn't exist
              const successDiv = document.createElement('div');
              successDiv.className = 'footer__newsletter-success';
              successDiv.setAttribute('role', 'status');
              successDiv.textContent = 'Thank you! Check your email for your discount code.';
              newsletterForm.insertBefore(successDiv, newsletterForm.firstChild);
              
              // Hide after 5 seconds
              setTimeout(() => {
                successDiv.remove();
              }, 5000);
            }
            
            // Clear the input field
            newsletterInput.value = '';
            newsletterInput.blur();
          } else {
            // Error handling
            const errorMessage = errors.textContent || 'There was an error submitting. Please try again.';
            showError(errorMessage);
          }
        } catch (e) {
          // Cross-origin or other error - assume success
          const successMessage = newsletterForm.querySelector('.footer__newsletter-success');
          if (!successMessage) {
            const successDiv = document.createElement('div');
            successDiv.className = 'footer__newsletter-success';
            successDiv.setAttribute('role', 'status');
            successDiv.textContent = 'Thank you! Check your email for your discount code.';
            newsletterForm.insertBefore(successDiv, newsletterForm.firstChild);
            
            setTimeout(() => {
              successDiv.remove();
            }, 5000);
          }
          newsletterInput.value = '';
          newsletterInput.blur();
        }
        
        // Restore original target
        if (originalTarget) {
          newsletterForm.setAttribute('target', originalTarget);
        } else {
          newsletterForm.removeAttribute('target');
        }
      };
      
      // Submit the form to iframe
      newsletterForm.submit();
      
      return false;
    });
    
    // Check for success message after page load (in case form was submitted normally)
    const successMessage = newsletterForm?.querySelector('.footer__newsletter-success');
    if (successMessage && successMessage.textContent.trim()) {
      // Success message is already displayed by Shopify
      // Clear the input field
      if (newsletterInput) {
        newsletterInput.value = '';
      }
    }
  }
});

// Discount Popup
document.addEventListener('DOMContentLoaded', () => {
  const discountPopup = document.getElementById('discount-popup');
  const discountTrigger = document.getElementById('discount-popup-trigger');
  const discountClose = discountPopup?.querySelector('.discount-popup__close');
  const discountDismiss = document.getElementById('discount-popup-dismiss');
  const discountBackdrop = discountPopup?.querySelector('.discount-popup__backdrop');
  const discountForm = document.getElementById('discount-popup-form');
  
  if (!discountPopup || !discountTrigger) return;
  
  // Check if user has already dismissed the popup (using localStorage)
  const hasDismissed = localStorage.getItem('discount-popup-dismissed');
  
  function openPopup() {
    discountPopup.classList.add('active');
    discountTrigger.classList.add('hidden');
    document.body.style.overflow = 'hidden';
  }
  
  function closePopup() {
    discountPopup.classList.remove('active');
    // Slide button back in based on position
    const position = discountTrigger.classList.contains('discount-popup-trigger--bottom-right') || 
                     discountTrigger.classList.contains('discount-popup-trigger--top-right') ? 'right' : 'left';
    discountTrigger.classList.remove('hidden');
    document.body.style.overflow = '';
  }
  
  // Open popup when trigger is clicked
  discountTrigger.addEventListener('click', () => {
    openPopup();
  });
  
  // Close popup when close button is clicked
  if (discountClose) {
    discountClose.addEventListener('click', () => {
      closePopup();
    });
  }
  
  // Close popup when dismiss link is clicked
  if (discountDismiss) {
    discountDismiss.addEventListener('click', () => {
      localStorage.setItem('discount-popup-dismissed', 'true');
      closePopup();
    });
  }
  
  // Close popup when backdrop is clicked
  if (discountBackdrop) {
    discountBackdrop.addEventListener('click', () => {
      closePopup();
    });
  }
  
  // Close popup on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && discountPopup.classList.contains('active')) {
      closePopup();
    }
  });
  
  // Phone number validation and formatting
  const phoneInput = discountForm?.querySelector('#discount-popup-phone');
  const errorElement = document.getElementById('discount-popup-error');
  
  function formatPhoneNumber(value) {
    // Remove all non-digit characters
    const phoneNumber = value.replace(/\D/g, '');
    
    // Format as (XXX) XXX-XXXX
    if (phoneNumber.length === 0) return '';
    if (phoneNumber.length <= 3) return `(${phoneNumber}`;
    if (phoneNumber.length <= 6) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  }
  
  function validatePhoneNumber(phoneNumber) {
    // Remove formatting to get just digits
    const digits = phoneNumber.replace(/\D/g, '');
    
    // Must be exactly 10 digits for US phone numbers
    if (digits.length !== 10) {
      return {
        valid: false,
        message: 'Please enter a valid 10-digit phone number'
      };
    }
    
    // Check for invalid patterns (all same digit, etc.)
    if (/^(\d)\1{9}$/.test(digits)) {
      return {
        valid: false,
        message: 'Please enter a valid phone number'
      };
    }
    
    return {
      valid: true,
      formatted: formatPhoneNumber(digits),
      digits: digits
    };
  }
  
  function showError(message) {
    if (errorElement && phoneInput) {
      errorElement.textContent = message;
      errorElement.classList.add('show');
      phoneInput.classList.add('error');
    }
  }
  
  function hideError() {
    if (errorElement && phoneInput) {
      errorElement.textContent = '';
      errorElement.classList.remove('show');
      phoneInput.classList.remove('error');
    }
  }
  
  // Format phone number as user types
  if (phoneInput) {
    phoneInput.addEventListener('input', (e) => {
      const formatted = formatPhoneNumber(e.target.value);
      e.target.value = formatted;
      
      // Validate on input
      const validation = validatePhoneNumber(formatted);
      if (formatted.length > 0 && !validation.valid) {
        showError(validation.message);
      } else {
        hideError();
      }
    });
    
    // Validate on blur
    phoneInput.addEventListener('blur', (e) => {
      const validation = validatePhoneNumber(e.target.value);
      if (e.target.value.length > 0 && !validation.valid) {
        showError(validation.message);
      } else {
        hideError();
      }
    });
    
    // Clear error on focus
    phoneInput.addEventListener('focus', () => {
      hideError();
    });
  }
  
  // Handle phone form button click (NOT form submission - button is type="button")
  const phoneSubmitButton = discountForm?.querySelector('button[data-phone-submit]');
  
  if (phoneSubmitButton) {
    phoneSubmitButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const phoneInput = discountForm.querySelector('#discount-popup-phone');
      const phoneNumber = phoneInput?.value || '';
      
      // Validate phone number
      const validation = validatePhoneNumber(phoneNumber);
      
      if (!validation.valid) {
        showError(validation.message);
        phoneInput.focus();
        return false;
      }
      
      // Store phone number and show email popup (NO SUBMISSION)
      if (phoneInput && validation.digits) {
        // Store phone number for the email form
        const phoneValue = '+1' + validation.digits;
        sessionStorage.setItem('discount-popup-phone', phoneValue);
        
        // Close phone popup
        closePopup();
        
        // Open email popup after a brief delay for smooth transition
        setTimeout(() => {
          const emailPopup = document.getElementById('email-popup');
          const phoneField = document.getElementById('email-popup-phone-field');
          
          if (emailPopup && phoneField) {
            phoneField.value = phoneValue;
            
            // Use the global function to open email popup
            if (window.openEmailPopup) {
              window.openEmailPopup(phoneValue);
            } else {
              // Fallback
              emailPopup.classList.add('active');
              document.body.style.overflow = 'hidden';
              const emailInput = document.getElementById('email-popup-email');
              if (emailInput) {
                setTimeout(() => emailInput.focus(), 300);
              }
            }
          }
        }, 300);
        
        return false;
      }
    });
  }
  
  // Also prevent form submission if somehow triggered
  if (discountForm) {
    discountForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }
  
  // Handle form errors from Shopify
  if (discountForm) {
    const formErrors = discountForm.querySelector('.form-error, .errors');
    if (formErrors) {
      showError('There was an error submitting your phone number. Please try again.');
    }
  }
});

// Email Popup (Secondary) - Use document-level event delegation (always active)
(function() {
  let emailPopup, emailForm, emailInput, emailError, phoneField;
  
  // Wait for DOM to be ready
  function initEmailPopup() {
    emailPopup = document.getElementById('email-popup');
    emailForm = document.getElementById('email-popup-form');
    
    if (!emailPopup || !emailForm) {
      setTimeout(initEmailPopup, 100);
      return;
    }
  
    // CRITICAL: Remove form action and prevent any default submission
    emailForm.setAttribute('action', 'javascript:void(0);');
    emailForm.setAttribute('onsubmit', 'return false;');
    emailForm.setAttribute('method', 'post');
    
    // Get references to all elements
    emailInput = document.getElementById('email-popup-email');
    emailError = document.getElementById('email-popup-error');
    phoneField = document.getElementById('email-popup-phone-field');
  
    function closeEmailPopup() {
      if (emailPopup) {
        emailPopup.classList.remove('active');
        document.body.style.overflow = '';
        // Clear stored data when closing
        sessionStorage.removeItem('discount-popup-phone');
        sessionStorage.removeItem('discount-popup-email');
      }
    }
    
    function openEmailPopup(phoneNumber) {
    // Get phone number from parameter or sessionStorage
    const storedPhone = phoneNumber || sessionStorage.getItem('discount-popup-phone');
    
    // Set the phone number in the hidden field
    if (phoneField && storedPhone) {
      phoneField.value = storedPhone;
    }
    
    emailPopup.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Attach event listeners when popup opens (try multiple times to ensure it works)
    setTimeout(() => {
      attachEmailPopupListeners();
    }, 50);
    
    setTimeout(() => {
      attachEmailPopupListeners();
    }, 200);
    
    setTimeout(() => {
      attachEmailPopupListeners();
    }, 500);
    
    // Focus on email input
    if (emailInput) {
      setTimeout(() => emailInput.focus(), 300);
    }
  }
  
    // Make functions globally available
    window.openEmailPopup = openEmailPopup;
    window.closeEmailPopup = closeEmailPopup;
    
    // Email validation function
    function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
    // Submit collected data to Shopify (phone + email) - ONLY called on final submit
    async function submitDiscountData() {
    const email = emailInput?.value.trim() || '';
    const phone = sessionStorage.getItem('discount-popup-phone') || '';
    
    // Validate email
    if (!email) {
      if (emailError) {
        emailError.textContent = 'Email can\'t be blank';
        emailError.classList.add('show');
      }
      emailInput?.focus();
      return false;
    }
    
    if (!validateEmail(email)) {
      if (emailError) {
        emailError.textContent = 'Please enter a valid email address';
        emailError.classList.add('show');
      }
      emailInput?.focus();
      return false;
    }
    
    // Ensure phone number is set in hidden field
    if (phoneField && phone) {
      phoneField.value = phone;
    }
    
    // Get submit button for UI feedback
    const submitButton = emailForm.querySelector('[data-email-submit]');
    const originalText = submitButton?.textContent || 'SUBMIT';
    
    // Disable button and show loading
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'SUBMITTING...';
    }
    
    // Instead of AJAX, submit the form normally to a hidden iframe to avoid page reload
    // This way Shopify's form handling (including CSRF tokens) works properly
    try {
      // Create a hidden iframe for form submission
      let iframe = document.getElementById('email-popup-submit-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'email-popup-submit-iframe';
        iframe.name = 'email-popup-submit-iframe';
        iframe.style.display = 'none';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);
      }
      
      // Set form action and target
      const originalAction = emailForm.getAttribute('action');
      const originalTarget = emailForm.getAttribute('target');
      emailForm.setAttribute('action', '/contact');
      emailForm.setAttribute('target', 'email-popup-submit-iframe');
      emailForm.setAttribute('method', 'post');
      
      // Listen for iframe load to detect submission completion
      iframe.onload = function() {
        // Check if submission was successful (iframe will load the contact page)
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          const errors = iframeDoc.querySelector('.form-error, .errors, [class*="error"]');
          
          if (!errors) {
            // Success
            if (submitButton) {
              submitButton.textContent = 'SUCCESS!';
              submitButton.style.backgroundColor = '#28a745';
            }
            
            // Mark as dismissed
            localStorage.setItem('discount-popup-dismissed', 'true');
            
            // Close popup after delay
            setTimeout(() => {
              closeEmailPopup();
              // Reset button
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalText;
                submitButton.style.backgroundColor = '';
              }
            }, 1500);
          } else {
            // Error handling
            const errorMessage = errors.textContent || 'There was an error submitting. Please try again.';
            console.error('Form submission error:', errorMessage);
            if (emailError) {
              emailError.textContent = errorMessage;
              emailError.classList.add('show');
            }
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalText;
            }
          }
        } catch (e) {
          // Cross-origin or other error - assume success if no error message visible
          if (submitButton) {
            submitButton.textContent = 'SUCCESS!';
            submitButton.style.backgroundColor = '#28a745';
          }
          localStorage.setItem('discount-popup-dismissed', 'true');
          setTimeout(() => {
            closeEmailPopup();
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalText;
              submitButton.style.backgroundColor = '';
            }
          }, 1500);
        }
        
        // Restore original form attributes
        if (originalAction) {
          emailForm.setAttribute('action', originalAction);
        } else {
          emailForm.removeAttribute('action');
        }
        if (originalTarget) {
          emailForm.setAttribute('target', originalTarget);
        } else {
          emailForm.removeAttribute('target');
        }
      };
      
      // Submit the form normally (to iframe)
      emailForm.submit();
      
    } catch (error) {
      console.error('Error submitting discount data:', error);
      if (emailError) {
        emailError.textContent = 'Something went wrong. Please try again.';
        emailError.classList.add('show');
      }
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    }
    
    return false;
  }
  
    // Attach event listeners directly to elements when popup opens
    function attachEmailPopupListeners() {
    if (!emailPopup) {
      return;
    }
    
    if (!emailPopup.classList.contains('active')) {
      return;
    }
    
    // Get fresh references each time
    const closeBtn = emailPopup.querySelector('.email-popup__close');
    const dismissBtn = document.getElementById('email-popup-dismiss');
    const submitBtn = emailForm?.querySelector('[data-email-submit]');
    const backdrop = emailPopup.querySelector('.email-popup__backdrop');
    
    // Remove old listeners by cloning elements (preserve inline styles)
    if (closeBtn) {
      const newClose = closeBtn.cloneNode(true);
      // Preserve inline styles
      if (closeBtn.hasAttribute('style')) {
        newClose.setAttribute('style', closeBtn.getAttribute('style'));
      }
      closeBtn.parentNode.replaceChild(newClose, closeBtn);
      newClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeEmailPopup();
        return false;
      }, true);
    }
    
    if (dismissBtn) {
      const newDismiss = dismissBtn.cloneNode(true);
      // Preserve inline styles
      if (dismissBtn.hasAttribute('style')) {
        newDismiss.setAttribute('style', dismissBtn.getAttribute('style'));
      }
      dismissBtn.parentNode.replaceChild(newDismiss, dismissBtn);
      newDismiss.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        localStorage.setItem('discount-popup-dismissed', 'true');
        closeEmailPopup();
        return false;
      }, true);
    }
    
    if (submitBtn) {
      const newSubmit = submitBtn.cloneNode(true);
      // Preserve inline styles
      if (submitBtn.hasAttribute('style')) {
        newSubmit.setAttribute('style', submitBtn.getAttribute('style'));
      }
      submitBtn.parentNode.replaceChild(newSubmit, submitBtn);
      newSubmit.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitDiscountData();
        return false;
      }, true);
    }
    
    if (backdrop) {
      // For backdrop, just add listener (don't clone as it's a container)
      backdrop.addEventListener('click', function(e) {
        if (e.target === backdrop) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeEmailPopup();
          return false;
        }
      }, true);
    }
  }
  
    // Also use document-level delegation as backup (with more aggressive checking)
    document.addEventListener('click', function(e) {
      // Only handle clicks when email popup is active
      if (!emailPopup || !emailPopup.classList.contains('active')) return;
      
      // Close button (check for button or SVG inside)
      const closeBtn = e.target.closest('.email-popup__close');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeEmailPopup();
        return false;
      }
      
      // Check if clicked on SVG inside close button
      if (e.target.closest('.email-popup__close svg') || e.target.closest('.email-popup__close path')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeEmailPopup();
        return false;
      }
      
      // Dismiss button
      const dismissBtn = e.target.closest('#email-popup-dismiss');
      if (dismissBtn || e.target.id === 'email-popup-dismiss') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        localStorage.setItem('discount-popup-dismissed', 'true');
        closeEmailPopup();
        return false;
      }
      
      // Backdrop click
      if (e.target.classList.contains('email-popup__backdrop')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeEmailPopup();
        return false;
      }
      
      // Submit button
      const submitBtn = e.target.closest('[data-email-submit]');
      if (submitBtn || e.target.hasAttribute('data-email-submit')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitDiscountData();
        return false;
      }
    }, true); // Use capture phase
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && emailPopup && emailPopup.classList.contains('active')) {
        e.preventDefault();
        closeEmailPopup();
      }
    });
    
    // Email input validation
    if (emailInput) {
    emailInput.addEventListener('input', () => {
      if (emailError) {
        emailError.textContent = '';
        emailError.classList.remove('show');
      }
      emailInput.classList.remove('error');
    });
    
    emailInput.addEventListener('blur', (e) => {
      const email = e.target.value.trim();
      if (email && !validateEmail(email)) {
        if (emailError) {
          emailError.textContent = 'Please enter a valid email address';
          emailError.classList.add('show');
        }
        emailInput.classList.add('error');
      } else {
        if (emailError) {
          emailError.textContent = '';
          emailError.classList.remove('show');
        }
        emailInput.classList.remove('error');
      }
    });
  }
  
  // Prevent form submission (fallback)
  if (emailForm) {
    emailForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      submitDiscountData();
      return false;
    });
  }
  
    // Email input validation
    if (emailInput) {
      emailInput.addEventListener('input', () => {
        if (emailError) {
          emailError.textContent = '';
          emailError.classList.remove('show');
        }
        emailInput.classList.remove('error');
      });
      
      emailInput.addEventListener('blur', (e) => {
        const email = e.target.value.trim();
        if (email && !validateEmail(email)) {
          if (emailError) {
            emailError.textContent = 'Please enter a valid email address';
            emailError.classList.add('show');
          }
          emailInput.classList.add('error');
        } else {
          if (emailError) {
            emailError.textContent = '';
            emailError.classList.remove('show');
          }
          emailInput.classList.remove('error');
        }
      });
    }
    
    // Prevent form submission (fallback)
    if (emailForm) {
      emailForm.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        submitDiscountData();
        return false;
      });
    }
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmailPopup);
  } else {
    initEmailPopup();
  }
})();


